// extracted by mini-css-extract-plugin
export var container = "Article-module--container--AHpQG";
export var imageContainer = "Article-module--imageContainer--3iaX7";